import { Box, BoxProps } from "@chakra-ui/react";
import React, { PropsWithChildren } from "react";

const TouchableOpacity: React.FC<PropsWithChildren<BoxProps & {
  activeOpacity?: number
  hoverOpacity?: number
}>> = ({ 
  children, 
  hoverOpacity = 0.8, 
  activeOpacity = 0.6,
  ...props 
}) => (
  <Box
    transition="opacity 0.2s"
    _hover={{ opacity: hoverOpacity }}
    _active={{ opacity: activeOpacity }}
    cursor="pointer"
    {...props}
  >
    {children}
  </Box>
)

export default TouchableOpacity;